import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { cellStackSx, primaryTextSx, secondaryTextSx, tertiaryTextSx } from '../orders/list2/cellStyles';
import { FONT, WEIGHT } from '../../styles/foundation/typography';
import { SUCCESS, WARNING, ERROR } from '../../styles/foundation/colors';

// Colour-coded delay chip so severity reads at a glance. Thresholds are configurable because
// forward/pickup delays escalate in days while RTO ageing is measured in weeks: default is
// green < 3 days, amber 3–5, red 6+; RTO passes {amber:16, red:31}.
export const delayChip = (days, { amber = 3, red = 6 } = {}) => {
  const d = Number(days) || 0;
  const c = d < amber ? SUCCESS : d < red ? WARNING : ERROR;
  return (
    <Chip
      size="small"
      label={`${d} day${d === 1 ? '' : 's'}`}
      sx={{ fontFamily: FONT, fontWeight: WEIGHT.bold, fontSize: 11, height: 22, bgcolor: `${c}1f`, color: c, border: `1px solid ${c}40` }}
    />
  );
};

// Palette for the attempts donut (one colour per attempt bucket, escalating).
export const ATTEMPT_COLORS = ['#3783e7', '#2e9e6b', '#d99a3a', '#c0392b', '#7a4fb0', '#0f766e', '#8f2f2c'];

// Maps an attempts distribution ([{name, value}]) to Donut data with a colour per bucket.
export const attemptsDonutData = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((d, i) => ({ name: d.name, value: d.value, color: ATTEMPT_COLORS[i % ATTEMPT_COLORS.length] }));

// Pickup → Drop route cell, built from the address enrichment (order/search by AWB).
export const routeCell = (row, addrMap) => {
  const a = (addrMap && addrMap[row.awbNumber]) || {};
  const puLoc = [a.fromCity, a.fromPincode].filter(Boolean).join(' ');
  const dpLoc = [a.toCity, a.toPincode].filter(Boolean).join(' ');
  // Name is primary (what the reporter asked to see); city + pincode a secondary line.
  return (
    <Box sx={cellStackSx}>
      <Typography sx={secondaryTextSx}><Box component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Pickup: </Box>{a.fromName || puLoc || '—'}</Typography>
      {a.fromName && puLoc && <Typography sx={tertiaryTextSx}>{puLoc}</Typography>}
      <Typography sx={secondaryTextSx}><Box component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Drop: </Box>{a.toName || dpLoc || '—'}</Typography>
      {a.toName && dpLoc && <Typography sx={tertiaryTextSx}>{dpLoc}</Typography>}
      {row.merchantZone && <Typography sx={tertiaryTextSx}>{row.merchantZone}</Typography>}
    </Box>
  );
};
